import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AccountInfo, EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { filter, ReplaySubject, Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { SidebarComponent } from "./sidebar/sidebar/sidebar.component";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterModule, CommonModule, SidebarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {

  userName: any;
  isLoggedIn: any;

  private readonly _destroying$ = new Subject<void>();
  private msalInitialized$ = new ReplaySubject<void>(1);

  loadIntents() {
    this.httpClient.get('https://localhost:7210/api/intent').subscribe(data => {
      console.log(data);
    });
  }

  constructor(
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private httpClient: HttpClient
  ) { }

  ngOnInit(): void {

    this.msalInitialization();

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });

    // Move this to occur only after auth is confirmed
    // this.msalInitialized$.pipe(
    //   filter(() => this.isLoggedIn),
    //   takeUntil(this._destroying$)
    // ).subscribe(() => {

    // });


  }

  setLoginDisplay() {
    try {
      // Only try to access accounts if MSAL is initialized
      const accounts = this.authService.instance.getAllAccounts();
      this.isLoggedIn = accounts.length > 0;

      if (this.isLoggedIn) {
        const account = accounts[0];
        this.userName = account.name || account.username || 'User';
      }
    } catch (error) {
      console.warn('MSAL not yet initialized, skipping login display update');
      this.isLoggedIn = false;
      this.userName = null;
    }
  }

  msalInitialization() {
    // Handle redirect first - this is critical for the redirect flow
    this.authService.handleRedirectObservable().subscribe({
      next: (result) => {
        console.log('Redirect handled:', result);
        // Only update user status after redirect is handled
        this.msalInitialized$.next();
        this.updateUserStatus();
      },
      error: (error) => {
        console.error('Redirect error:', error);
        // Even on error, mark as initialized
        this.msalInitialized$.next();
      },
      complete: () => {
        console.log('Redirect observable completed');
      }
    });

    // Listen for MSAL events
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        console.log('MSAL interaction complete');
        this.updateUserStatus();
      });

    this.msalBroadcastService.msalSubject$
      .pipe(takeUntil(this._destroying$))
      .subscribe((result: EventMessage) => {
        if (result.eventType === EventType.LOGIN_SUCCESS) {
          console.debug('Login Success:', result);
        }
        this.updateUserStatus();
      });
  }

  private updateUserStatus(): void {
    try {
      const accounts = this.authService.instance.getAllAccounts();
      // Extract tenant ID and check if it matches allowed tenants
      //const tenantId = account.idTokenClaims?.tid;
      // 01583be4-f096-49f4-bd19-56b649a8482f - ICS.AI Corporate Directory
      // 7dbd3d8d-379e-4afd-b0f5-cdca8ef69e51 - ICS Technical Team Directory
      //const allowedTenants = ['01583be4-f096-49f4-bd19-56b649a8482f', '7dbd3d8d-379e-4afd-b0f5-cdca8ef69e51']; // Replace with actual tenant IDs
      //this.isAllowedTenant = allowedTenants.includes(tenantId || '');

      if (accounts.length > 0) {
        const account = accounts[0];
        this.isLoggedIn = true;
        this.userName = account.name || account.username || 'User';
        console.log('User account:', account);
      } else {
        this.isLoggedIn = false;
        this.userName = null;
      }
    } catch (error) {
      console.warn('Failed to update user status, MSAL may not be initialized', error);
      this.isLoggedIn = false;
      this.userName = null;
    }
  }


  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }


  login() {
    this.authService.loginRedirect();
    // Alternatively, use popup:
    // this.authService.loginPopup().subscribe(() => this.checkAccount());
  }

  logout() {
    //  this.authService.logoutRedirect({
    //    postLogoutRedirectUri: '/',
    //  });
    this.authService.logoutRedirect();
  }

}
